<template>
  <div @click="selectedItem = null,selectedProduct=null">
    <breadcrumbs home="Mixed-pack packing">
      <template v-slot:right>
        <v-menu offset-y v-if="company.permissions.includes('config.write')" :close-on-content-click="false" nudge-bottom="5" left max-width="500">
          <template v-slot:activator="{ on }">
            <v-icon small v-on="on">mdi-tune-variant</v-icon>
          </template>
          <production-packing-preferences />
        </v-menu>
      </template>
    </breadcrumbs>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container fluid class="pt-6 px-6 purtrak-scrollable">

            <v-overlay absolute :opacity="0.15" style="calc(100vh - 158px)"
                      v-if="!packedProducts.length && !loading && !packingId">
              <div style="position:relative;top:-300px;width:400px" class="d-inline-block purple white--text text-body-1 pa-5">
                Before you pack, you must have
                <template v-if="packedProducts.length===0">
                  mixed pack products defined.
                  <div class="mt-8 float-right">
                    <v-btn :to="{name:'InventoryProducts'}" color="primary" small>Products</v-btn>
                  </div>
                </template>
              </div>
            </v-overlay>

            <v-row dense>
              <v-col cols="6" sm="4" md="3">
                <date-picker v-model="packing.date" @change="refreshLot()"/>
              </v-col>
              <v-col cols="4" sm="3" lg="2" :offset-md="7">
                <v-text-field label="#" v-model="packing.number" :rules="[fieldRules.required,fieldRules.maxLength(20)]" outlined dense :counter="20"/>
              </v-col>
            </v-row>
            <v-row dense v-if="sites.length>1">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete outlined dense label="Site" v-model="packing.siteId" :items="sites" item-value="id" item-text="name"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <multi-level-select v-if="!!productCategories" label="Product to pack"  :menuData="productCategories" :second.sync="packing.productId" outlined
                                     persistent-hint @change="selectProduct"/>
                <v-autocomplete v-else v-model="packing.productId" outlined dense label="Product to pack" :rules="[requiredAlways]"
                                @change="selectProduct"
                                :items="packedProducts" item-text="name" item-value="id"
                                 persistent-hint/>
              </v-col>
              <v-col cols="6" sm="2">
                <v-tooltip bottom  max-width="300" nudge-top="20" open-delay="1000">
                  <template v-slot:activator="{on}">
                    <v-checkbox v-model="packing.dutyPaid" v-on="on" dense class="mt-1" @change="validate()">
                      <span slot="label" v-on="on">From/To duty-paid</span>
                    </v-checkbox>
                  </template>
                  If selected, source products and final product will all be in duty-paid inventory.
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row v-if="product.description" class="mb-4">
              <v-col cols="12" lg="8" class="primary--text">
                <em>{{product.description}}</em>
              </v-col>
            </v-row>
            <cases-bottles :cases.sync="packing.cases" :bottles.sync="packing.packs" :product="product"/>
            <v-row>
              <v-col cols="6" sm="2">
                <v-text-field v-model="packing.lot"
                              label="Product lot" outlined dense
                              :rules="[required,fieldRules.maxLength(20)]" :counter="20"/>
              </v-col>
            </v-row>

            <v-row class="my-2">
              <v-col cols="12" lg="8">
                <outlined-block title="Total products for pack(s)" :disabled="!edit" v-model="packing.pack" :rules="[productsCheck]">
                  <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                                :items="packing.products" item-key="uniqueId"
                                :headers="packingProductsHeaders"
                                :item-class="item => item.uniqueId=== selectedProduct ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                                @click.native.stop=""
                                @click:row="item => {selectedProduct = item.uniqueId; $nextTick(() => this.$refs.form.validate())}"
                                ref="bomTableBody">
                    <template v-slot:item.item="{item}">
                      <div class="ml-1">
                        {{products.find(product => product.id === item.id).name}}
                      </div>
                    </template>
                    <template v-slot:item.quantity="{item}">
                      {{ item.quantity }} bottles
                    </template>
                    <template v-slot:item.lot="{item}">
                      <v-combobox v-if="selectedProduct === item.uniqueId" dense outlined label="Lot" v-model="item.lot" :rules="[required,fieldRules.maxLength(20)]" :items="productLots(item.id)"
                                  class="text-body-2" no-data-text="No inventory" hide-details @change="validate()"/>
                      <div v-else class="ml-1" :class="{'error--text':required(item.lot) !== true}">
                        {{item.lot || 'Required'}}
                      </div>
                    </template>
                  </v-data-table>
                </outlined-block>
              </v-col>
            </v-row>

            <v-row class="my-2">
              <v-col cols="12" lg="8">
                <outlined-block title="Bill of materials" :disabled="!edit" v-model="packing.bom" :rules="[bomCheck]">
                  <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                                :items="packing.bom" item-key="uniqueId"
                                :no-data-text="packing.productId ? product.name + ' does not have a bill of materials' : 'No items specified'"
                                :headers="[{text:'',value:'add',width:'15%',align:'center',cellClass:'pa-0',divider:true},
                                          {text:'Item',value:'item',width:'35%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'},
                                          {text:'Quantity',value:'quantity',width:'25%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt',align:'right'},
                                          {text:'Lot',value:'lot',width:'25%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'}]"  class="no-sort"
                                :item-class="item => item.uniqueId=== selectedItem ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                                @click.native.stop=""
                                @click:row="item => {selectedItem = item.uniqueId; $nextTick(() => this.$refs.form.validate())}"
                                ref="bomTableBody">
                    <template v-slot:item.add="{item,index}">
                      <v-icon class="handle mt-n2" :disabled="!edit">mdi-drag</v-icon>
                      <v-btn class="mt-n2" icon @click.stop="deleteItem(index)" x-small :disabled="!edit"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <template v-slot:item.item="{item}">
                      <template v-if="selectedItem === item.uniqueId">
                        <multi-level-select v-if="itemCategories.length" :menuData="eligibleItems" :second.sync="item.id" @change="changeBOMItem(item, false)" outlined label="Item"/>
                        <v-autocomplete v-else :items="items" item-text="name" item-value="id" v-model="item.id" dense @change="changeBOMItem(item, false)" :rules="[required]" class="text-body-2" outlined label="Item"/>
                      </template>
                      <div v-else class="ml-1" :class="{'error--text':!item.id}">
                        {{bomItem(item.id).name}}
                      </div>
                    </template>
                    <template v-slot:item.quantity="{item}">
                      <decimal-number-input v-if="selectedItem === item.uniqueId" label="Quantity" v-model="item.quantity" prefix=""
                            :suffix="bomItem(item.id).trackUnits" :precision="bomItem(item.id).precision" class="text-body-2" @change="validate()"
                            :hint="packingId?'':bomItem(item.id).quantity" persistent-hint/>
                      <div v-else class="mr-1" :class="{'error--text':item.quantity < 0}">
                        {{item.quantity | number(bomItem(item.id).precision)}} {{bomItem(item.id).trackUnits}}
                      </div>
                    </template>
                    <template v-slot:item.lot="{item}">
                      <template v-if="bomItem(item.id).lotTracking">
                        <v-combobox v-if="selectedItem === item.uniqueId" dense outlined label="Lot" v-model="item.lot" :rules="[required,fieldRules.maxLength(20)]" :items="currentLots(item.id)"
                                    class="text-body-2" no-data-text="No inventory" @change="changeItemLot(item)"/>
                        <div v-else class="ml-1" :class="{'error--text':required(item.lot) !== true}">
                          {{item.lot || 'Required'}}
                        </div>
                      </template>
                      <div v-else>n/a</div>
                    </template>
                    <template v-slot:footer="{widths}">
                      <v-divider/>
                      <div @click="selectedItem = null" style="width:100%" class="py-2 px-0">
                        <div :style="'width:'+widths[0]+'px'" class="text-center">
                          <v-btn :disabled="!edit || items.length===0" fab color="primary" x-small @click.stop="addItem"><v-icon small>mdi-plus</v-icon></v-btn>
                        </div>
                      </div>
                    </template>
                  </v-data-table>
                </outlined-block>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" lg="8">
                <v-textarea label="Comments" rows="4"
                           v-model="packing.comments" outlined dense :rules="[fieldRules.maxLength(500)]" counter="500"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
        <template v-if="packingId && company.permissions.includes('production.write')">
          <v-switch :disabled="dirty"
                    v-model="edit" label="Edit" hide-details class="mt-0"/>
        </template>
        <v-spacer/>
        <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
        <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns';
import sortableJS from 'sortablejs';
import confirmLeave from '@/mixins/confirmLeave'
import CasesBottles from '@/components/CasesBottles'
import ProductionPackingPreferences from '@/views/production/packing/ProductionPackingPreferences'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ProductionPackingEdit',
  components: {ProductionPackingPreferences,CasesBottles},
  mixins: [confirmLeave,createHierarchyList],
  props: {
    packingId: {type:String, required:false},
    productId: {type:String, required:false},
  },
  data () {
    return {
      edit: false,
      packing: {date:format(new Date(), 'yyyy-MM-dd HH:mm:ss'),number:'',productId:'', dutyPaid: false,
                 siteId:this.$store.getters.sites(true)[0].id,
                 comments:'',cases:0,packs:0,lot:'',bom:[],products:[]},
      products: [],
      productCategories: null,
      items: [],
      itemCategories: [],

      dirty: false,
      saving: false,
      loading: true,
      selectedItem: null,
      selectedProduct: null,
      valid: true,
      requiredAlways: v => !!v || 'Required',
      required: v => !!v || 'Required',
      sortable: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    lotTracking() {
      return this.company.settings.lotTrackingForProducts && (!this.packing.dutyPaid || this.company.settings.lotTrackingForDutyPaid);
    },
    packingProductsHeaders() {
      const headers = [{text:'Product',value:'item',width:'35%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'},
                       {text:'Quantity',value:'quantity',width:'25%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt',align:'right'}];
      if (this.lotTracking)
         headers.push({text:'Lot',value:'lot',width:'25%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'});
      return headers;
    },
    sites() {
      return this.$store.getters.sites(!this.packingId, {B265:true,B266:true});
    },
    product() {
      return this.products.find(product => product.id === this.packing.productId) || {mixedPack:true}
    },
    packedProducts() {
      return this.products.filter(product => product.mixedPack);
    },
    eligibleItems() {
      const categories = this.createHierarchyList(this.itemCategories);
      for (const category of categories) {
        const sub = this.items.filter(item => item.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//      const items = [...categories.filter(category => !category.disabled)];
      const items = categories;
      const leftOver = this.items.filter(item => !item.category?.id);
      if (leftOver.length)
        items.push({divider:true},{name:'Other items',id:'x',menu:leftOver});
      return items;
    }
  },
  async mounted() {
    const productCategories = [];
    await Promise.all([
      this.$lazyListLoad(this.itemCategories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]),
      this.$lazyListLoad(productCategories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Product'}]),
      this.$lazyListLoad(this.products, 'products2', 'id,name,caseSize,bottleSize,mixedPack,category{id},allowVariableStrength', 100, !this.packingId ? [{field:'active', comparator:'eq', value:'true'}] : []),
      this.$lazyListLoad(this.items, 'items2', 'id,name,trackUnits,lotTracking,type,precision,category{id}', 100, !this.packingId ? [{field:'active', comparator:'eq', value:'true'}] : [])
    ]);

    let packing;
    if (this.packingId!==undefined) {
      const results = await this.$apiCall(`query ProductionPackingEdit($id:ID!) {
                                            packing(id:$id) {
                                              id,date,number,siteId,productId,dutyPaid,comments,packs,lot
                                              bom{type,id,quantity,lot}
                                              products{id,quantity,lot}
                                            }
                                          }`,
                                          {id:this.packingId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      packing = results.data.packing;
    }

    if (productCategories.length) {
      const categories = this.createHierarchyList(productCategories);
      for (const category of categories) {
        const sub = this.packedProducts.filter(product => product.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//      this.productCategories = [...categories.filter(category => !category.disabled)];
      this.productCategories = categories;
      const leftOver = this.packedProducts.filter(product => !product.category?.id);
      if (leftOver.length)
        this.productCategories.push({divider:true},{name:'Other products',id:'x',menu:leftOver});
    }

    if (this.packingId) {
      let uniqueId = Date.now();
      packing.bom.forEach(item => item.uniqueId = uniqueId++);
      Object.assign(this.packing, packing, {cases:0});
      await this.selectProduct();
      this.packing.cases = Math.floor(this.packing.packs / this.product.caseSize);
      this.packing.packs -= this.packing.cases * this.product.caseSize;
    }
    else if (this.packedProducts.length) {
      const results = await this.$apiCall(`query ProductionPackingEdit {
                                              packingNextNumber
                                            }`);
      if (!results.error)
        this.packing.number = results.data.packingNextNumber;
      this.packing.productId = this.productId || '';
      this.edit = true;
      await this.selectProduct();
    }

    await this.refreshLot();
    this.$nextTick(() => {
      this.dirty = false
      this.validate();
    });
    this.loading = false;

    const _self = this;
    this.sortable = sortableJS.create(this.$refs.bomTableBody.$el.querySelector('tbody'), {
      handle: '.handle',
      onEnd({newIndex, oldIndex}) {
        const rowSelected = _self.packing.bom.splice(oldIndex, 1)[0];
        _self.packing.bom.splice(newIndex, 0, rowSelected);
      }
    })
  },
  beforeDestroy() {
    this.sortable.destroy();
  },
  watch: {
    packing: {
      handler() {
        this.dirty = true;
      },
      immediate: true,
      deep: true
    },
    'packing.cases'() {
      this.bom();
    },
    'packing.packs'() {
      this.bom();
    }
  },

  methods: {
    validate() {
      this.$nextTick(() => {
        this.$refs.form?.validate();
      });
    },
    bomCheck() {
      if (!this.edit)
        return true;
      if (!this.product || !this.product.bom)
        return false;

      // Must meet minimum requirements on product BOM
      const packs = this.packing.cases * this.product.caseSize + this.packing.packs;
      const cases = Math.floor(packs / this.product.caseSize);
      for (const productItem of this.product.bom) {
        if (productItem.optional)
          continue;
        const quantityRequired = productItem.quantity * (productItem.per === 'Bottle' ? packs : (productItem.per === 'Case' ? cases : 1));
        let quantity = quantityRequired;
        this.packing.bom.forEach(bomItem => {
          if (bomItem.id === productItem.id)
            quantity -= bomItem.quantity;
        });
        if (quantity > 0) {
          const item = this.bomItem(productItem.id);
          return `A minimum ${quantityRequired} ${item.trackUnits} of ${item.name} required`;
        }
      }
      return true;
    },
    productsCheck() {
      if (this.lotTracking && this.packing.products.some(product => !product.lot))
        return 'Lot codes must be specified';
      return true;
    },
    addItem() {
      const bomItem = {type:'Item',id:'',quantity:0,lot:'',uniqueId:Date.now()};
      this.changeBOMItem(bomItem, false);
      this.packing.bom.push(bomItem);
      this.selectedItem = bomItem.uniqueId;
      this.validate();
    },
    deleteItem(index) {
      this.packing.bom.splice(index, 1);
    },
    async changeBOMItem(bomItem, forceRefresh) {
      const item = this.bomItem(bomItem.id);
      if (!item.id)
        return;
      if (forceRefresh || !item.sites) {
        const results = await this.$apiCall(`query ProductionPackingEdit($id:ID!, $date:DateTime) {
                                                  item(id:$id) {
                                                    sites(asof:$date) {siteId,lot,quantity}
                                                  }
                                                }`,
                                            {id:item.id,date:this.packing.date});
        if (!results.error)
          this.$set(item, 'sites', results.data.item.sites);
      }
      bomItem.lot = item.sites?.some(site => site.siteId === this.packing.siteId && site.lot === bomItem.lot) ? bomItem.lot : '';

      const site = item.sites?.find(site => site.siteId === this.packing.siteId);
      item.quantity = item.type === 'Item' ? `${site && !item.lotTracking ? this.$number(site.quantity, item.precision) : '0'} ${item.trackUnits}` : '';

      this.validate();
    },
    async changePackProduct(packProduct) {
      const product = this.products.find(product => product.id === packProduct.id)
      const results = await this.$apiCall(`query ProductionPackingEdit($id:ID!, $date:DateTime) {
                                                product(id:$id) {
                                                  sites(asof:$date) {siteId,lot}
                                                }
                                              }`,
                                          {id:product.id,date:this.packing.date});
      if (!results.error)
        this.$set(product, 'sites', results.data.product.sites);
    },
    productLots(id) {
      const product = this.products.find(product => product.id === id);
      return product.sites ? product.sites.filter(site => site.siteId === this.packing.siteId).map(site => site.lot) : [];
    },
    changeItemLot(bomItem) {
      const item = this.bomItem(bomItem.id);
      const site = item.sites?.find(site => site.siteId === this.packing.siteId && site.lot === bomItem.lot);
      item.quantity = `${site ? this.$number(site.quantity, item.precision) : '0'} ${item.trackUnits}`;
    },
    currentLots(id) {
      const item = this.bomItem(id);
      return item && item.sites ?
                                item.sites.filter(site => site.siteId === this.packing.siteId).map(site => site.lot)
                                : [];
    },

    async selectProduct() {
      if (this.packing.productId && !this.product.bom) {
        const results = await this.$apiCall(`query ProductionPackingEdit($id:ID!) {
                                              product(id:$id) {
                                                description,mixedPack
                                                bom{type,id,quantity,per,optional}
                                                pack{id,quantity}
                                              }
                                            }`,
                                            {id:this.product.id});
        if (!results.error) {
          this.product.description = results.data.product.description;
          this.product.bom = results.data.product.bom;
          this.product.products = results.data.product.pack;
        }
      }
      this.bom();
    },
    bomItem(itemId) {
      return this.items.find(item => item.id === itemId) || {name:'MISSING', trackUnits:'', precision:0, lotTracking:false};
    },
    bom() {
      if (!this.product.products || !this.edit)
        return;
      let uniqueId = 1;
      this.packing.bom = this.product.bom?.map(productItem => {
        const packs = this.packing.cases * this.product.caseSize + this.packing.packs;
        const cases = Math.floor(packs / this.product.caseSize);
        const quantity = productItem.quantity * (productItem.per === 'Bottle' ? packs : (productItem.per === 'Case' ? cases : 1));
        const lot = this.packing.bom.find(item => item.id === productItem.id)?.lot;
        return {type:productItem.type,id:productItem.id,quantity,lot,uniqueId:uniqueId++};
      });
      this.packing.products = this.product.products.map(product => {
        const packs = this.packing.cases * this.product.caseSize + this.packing.packs;
        const quantity = product.quantity * packs;
        const lot = this.packing.products.find(p => p.id === product.id)?.lot;
        return {id:product.id, quantity, lot, uniqueId:uniqueId++};
      });

      for (const bomItem of this.packing.bom ?? [])
        this.changeBOMItem(bomItem, false);

      for (const product of this.packing.products)
        this.changePackProduct(product);

      this.validate();
    },
    async refreshLot() {
      if (this.packingId)    // Don't do for editing existing packing
        return;
      this.loading = true;
      const results = await this.$apiCall(`query ProductionPackingEdit($asof:DateTime!) {
                                            lotUnique(prefix:"P",date:$asof)
                                          }`,
                                          {asof:this.packing.date});
      if (!results.error)
        this.packing.lot = results.data.lotUnique;

      for (const bomItem of this.packing.bom)
        await this.changeBOMItem(bomItem, true);

      for (const product of this.packing.products)
        await this.changePackProduct(product);

      this.loading = false;
    },

    cancel() {
      this.$router.back();
    },
    async save() {
      const incomplete = this.packing.bom.some(item => !item.id ||
                                                        item.quantity < 0 ||
                                                        (this.bomItem(item.id).lotTracking && this.required(item.lot) !== true));
      if (!this.valid || incomplete) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {created, ...input} = this.packing;
      input.bom = this.packing.bom.map(item => {
        // eslint-disable-next-line no-unused-vars
        const {uniqueId, ...i} = item;
        return i;
      });
      input.products = this.packing.products.map(product => {
        // eslint-disable-next-line no-unused-vars
        const {uniqueId, ...p} = product;
        return p;
      });
      const results = await this.$apiCall(`mutation ProductionPackingEdit($input: PackingInput!) {
                                             packingCreate(input:$input) {id}
                                           }`,
                                          {input})

      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.packing.id?'Updated':'Created'} packing for ${this.product.name}`});
      }
    }
  }
}
</script>